import { useEffect, useState } from "react";
import { C, F } from "../theme/tokens";
import { CATEGORIE, EVENTO_PREFERENZE, applicaConsenso, leggiConsenso, registraConsenso, salvaConsenso } from "./consenso";

/**
 * Banner dei cookie, nello stile del sito.
 *
 * Tre scelte con la stessa evidenza, come chiede il Garante: "Rifiuta",
 * "Personalizza" e "Accetta tutti". Compare solo se non c'e' una scelta
 * valida; si riapre da "Preferenze cookie" nel pie' di pagina. La scelta
 * salvata viene comunicata ai tag anche al caricamento, cosi' chi ha gia'
 * scelto non vede niente e i tag partono (o restano fermi) subito.
 */

const bottone = (variante) => ({
  height: 40, padding: "0 16px", borderRadius: 8, fontFamily: F.b, fontSize: 13, fontWeight: 600, cursor: "pointer",
  border: variante === "primario" ? "1px solid transparent" : `1px solid ${C.border}`,
  background: variante === "primario" ? C.btnBg : C.white,
  color: variante === "primario" ? "#fff" : C.textTitle,
});

export default function CookieBanner({ onApriPolicy }) {
  const [visibile, setVisibile] = useState(false);
  const [pannello, setPannello] = useState(false);
  const [scelta, setScelta] = useState({ statistiche: false, marketing: false });

  useEffect(() => {
    const salvata = leggiConsenso();
    if (salvata) {
      applicaConsenso(salvata);
      setScelta({ statistiche: salvata.statistiche, marketing: salvata.marketing });
    } else {
      setVisibile(true);
    }
    const riapri = () => {
      const attuale = leggiConsenso();
      if (attuale) setScelta({ statistiche: attuale.statistiche, marketing: attuale.marketing });
      setPannello(true);
      setVisibile(true);
    };
    window.addEventListener(EVENTO_PREFERENZE, riapri);
    return () => window.removeEventListener(EVENTO_PREFERENZE, riapri);
  }, []);

  const conferma = (valori) => {
    const salvata = salvaConsenso(valori);
    applicaConsenso(salvata);
    // La prova del consenso: una riga nel registro, con l'origine della
    // scelta (il banner alla prima visita, o le preferenze riaperte).
    registraConsenso(salvata, pannello ? "preferenze" : "banner");
    setScelta({ statistiche: salvata.statistiche, marketing: salvata.marketing });
    setPannello(false);
    setVisibile(false);
  };

  if (!visibile) return null;

  return (
    <div
      role="dialog"
      aria-label="Preferenze sui cookie"
      aria-live="polite"
      style={{
        position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 9900, margin: "0 auto", maxWidth: 760,
        background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, boxShadow: C.shadowLg,
        padding: 20, fontFamily: F.b, color: C.textBody, boxSizing: "border-box",
      }}
    >
      <p style={{ margin: 0, fontSize: 14, lineHeight: 1.55 }}>
        Usiamo cookie tecnici per far funzionare il sito e, solo con il tuo consenso, cookie statistici e di marketing
        (Google Analytics, Google Ads, Meta). Puoi cambiare idea quando vuoi da &laquo;Preferenze cookie&raquo; nel pi&egrave; di pagina.{" "}
        <button type="button" onClick={onApriPolicy} style={{ background: "none", border: "none", padding: 0, color: C.smartBlue, fontWeight: 600, cursor: "pointer", fontFamily: F.b, fontSize: 14, textDecoration: "underline" }}>Cookie policy</button>
      </p>

      {pannello && (
        <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
          <label style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13, lineHeight: 1.5 }}>
            <input type="checkbox" checked disabled style={{ marginTop: 3 }} />
            <span><strong>Tecnici</strong> (sempre attivi): sessione di accesso e memoria dei lavori in corso. Senza, il sito non funziona.</span>
          </label>
          {CATEGORIE.map((c) => (
            <label key={c.chiave} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13, lineHeight: 1.5, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={Boolean(scelta[c.chiave])}
                onChange={(e) => setScelta((prev) => ({ ...prev, [c.chiave]: e.target.checked }))}
                style={{ marginTop: 3, accentColor: C.smartBlue }}
              />
              <span><strong>{c.nome}</strong>: {c.descrizione}</span>
            </label>
          ))}
        </div>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 16, justifyContent: "flex-end" }}>
        {pannello ? (
          <>
            <button type="button" style={bottone()} onClick={() => conferma({ statistiche: false, marketing: false })}>Rifiuta</button>
            <button type="button" style={bottone("primario")} onClick={() => conferma(scelta)}>Salva le preferenze</button>
          </>
        ) : (
          <>
            <button type="button" style={bottone()} onClick={() => conferma({ statistiche: false, marketing: false })}>Rifiuta</button>
            <button type="button" style={bottone()} onClick={() => setPannello(true)}>Personalizza</button>
            <button type="button" style={bottone("primario")} onClick={() => conferma({ statistiche: true, marketing: true })}>Accetta tutti</button>
          </>
        )}
      </div>
    </div>
  );
}
